import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

import { useGlobalEvaluations } from './useGlobalEvaluations';

/**
 * Custom hook to manage document title and meta tags based on
 * authentication and authorization status.
 *
 * - Shows "ZEISS" when not authenticated or not authorized
 * - Shows "ZEISS Identity Management Portal" when authenticated and authorized
 */
export const useDocumentMetadata = () => {
  const auth = useAuth();
  const { canUseApp, isLoading } = useGlobalEvaluations();

  useEffect(() => {
    const isAuthorized = auth.isAuthenticated && !isLoading && canUseApp;

    const title = isAuthorized ? 'ZEISS Identity Management Portal' : 'ZEISS';

    document.title = title;

    const appleMobileMetaTag = document.querySelector(
      'meta[name="apple-mobile-web-app-title"]',
    );

    if (appleMobileMetaTag) {
      appleMobileMetaTag.setAttribute('content', title);
    }
  }, [auth.isAuthenticated, auth.user?.profile?.email, canUseApp, isLoading]);
};
